<template>
  <v-app>
    <v-main class="background">
      <div v-if="$vuetify.breakpoint.xs" class="play">
        <a href="https://play.google.com/store">
          <img src="./assets/images/playstore.svg" alt="playstore icon"
        /></a>
      </div>

      <div v-else>
        <NavBar />
        <router-view></router-view>
      </div>
    </v-main>

    <div class="footer">
      <Footer />
    </div>
  </v-app>
</template>

<script>
import NavBar from "@/components/components-base/nav/NavBar";
import Footer from "@/components/components-base/footer/Footer.vue";

export default {
  name: "app",
  data() {
    return {};
  },
  components: { NavBar, Footer },
  created() {
    if (!$cookies.isKey("config")) {
      let config = { timePref: "month", theme: "dark", lang: "fr" };
      $cookies.set("config", config, "1y");
    }
    if (!$cookies.isKey("dg2User")) {
      let dg2User = null;
      $cookies.set("dg2User", dg2User, "1d");
    }

    let cookiesConfig = $cookies.get("config");
    this.timePeriod = cookiesConfig.timePref;
  },
};
</script>
<style lang="scss">
:root {
  --color-bg-light: rgb(240, 240, 240);
  --color-bg-dark: rgb(61, 61, 61);

  --light-color-shadow-light: rgb(255, 255, 255);
  --dark-color-shadow-light: rgb(97, 97, 97);

  --light-color-shadow-dark: rgb(202, 202, 202);
  --dark-color-shadow-dark: rgb(39, 39, 39);

  --light-weekend-bg-color: rgb(224, 224, 224);
  --light-holiday-bg-color: rgba(128, 128, 128, 0.527);
  --dark-weekend-bg-color: rgb(78, 78, 78);

  --light-border-color: var(--light-weekend-bg-color);
  --dark-border-color: var(--dark-weekend-bg-color);

  --light-text-color: rgb(65, 65, 65);
  --dark-text-color: rgb(241, 241, 241);

  --dark-elevation-color: rgb(34, 34, 34);
  --light-elevation-color: rgb(189, 189, 189);

  --light-card-color: rgb(255, 255, 255);
  --dark-card-color: rgb(39, 39, 39);

  --main-bg-color: var(--color-bg-light);

  --shadow-dark: var(--light-color-shadow-dark);
  --shadow-light: var(--light-color-shadow-light);

  --weekend-bg-color: var(--light-weekend-bg-color);
  --holiday-bg-color: var(--light-holiday-bg-color);
  --border-color: var(--light-border-color);

  --text-color: var(--light-text-color);
  --scroll-bar-color-1: rgb(175, 175, 175);

  --row-height: 3rem;
  --column-width: var(--column-default);
  --column-week: 9vw; // 9vw;
  --column-default: 3rem; // 2.6 rem
  --row-height-event: 2.5rem;
  --height-container: 36rem;
  --info-card-shadow: var(--light-elevation-color);
  --card-color: var(--light-card-color);
}

.play {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.neumorphism-out {
  box-shadow: 2.5px 2.5px 2.5px var(--shadow-dark),
    -2.5px -2.5px 2.5px var(--shadow-light);
  transition: box-shadow 0.5s;
}
.neumorphism-out-animated {
  box-shadow: 2.5px 2.5px 2.5px var(--shadow-dark),
    -2.5px -2.5px 2.5px var(--shadow-light);
  animation: shadowFadeOut 0.5s linear;
  transition: box-shadow 0.5s;

  &:hover {
    background: linear-gradient(
      145deg,
      var(--shadow-dark),
      var(--shadow-light)
    );
    box-shadow: 2.5px 2.5px 2.5px var(--shadow-dark),
      -2.5px -2.5px 2.5px var(--shadow-light);
    animation: shadowFadeIn 0.5s linear;
  }

  @keyframes shadowFadeOut {
    0% {
      background: linear-gradient(
        145deg,
        var(--shadow-dark),
        var(--shadow-light)
      );
      box-shadow: 2.5px 2.5px 2.5px var(--shadow-dark),
        -2.5px -2.5px 2.5px var(--shadow-light);
    }
    100% {
      box-shadow: 2.5px 2.5px 2.5px var(--shadow-dark),
        -2.5px -2.5px 2.5px var(--shadow-light);
    }
  }

  @keyframes shadowFadeIn {
    0% {
      box-shadow: 2.5px 2.5px 2.5px var(--shadow-dark),
        -2.5px -2.5px 2.5px var(--shadow-light);
    }
    100% {
      background: linear-gradient(
        145deg,
        var(--shadow-dark),
        var(--shadow-light)
      );
      box-shadow: 2.5px 2.5px 2.5px var(--shadow-dark),
        -2.5px -2.5px 2.5px var(--shadow-light);
    }
  }
}
.neumorphism-in {
  transition: box-shadow 0.5s;

  box-shadow: inset 2.5px 2.5px 2.5px var(--shadow-dark),
    inset -2.5px -2.5px 2.5px var(--shadow-light);
}
.neumorphism-curved {
  transition: box-shadow 0.5s;

  // background: linear-gradient(145deg, var(--shadow-light), #d6d6d6);
  box-shadow: 2.5px 2.5px 2.5px var(--shadow-dark),
    -2.5px -2.5px 2.5px var(--shadow-light);
}

html,
body {
  //overflow-y: scroll;
  // -webkit-user-select: none; /* Safari */
  // -ms-user-select: none; /* IE 10 and IE 11 */
  // user-select: none; /* Standard syntax */
  transition: color 0.5s;
  background: var(--main-bg-color);

  & > div {
    color: var(--text-color);
  }
}

a {
  text-decoration: none;
  transition: color 0.5s;
}

.background {
  background: var(--main-bg-color);
}

.tabs {
  display: flex;
  margin: 5px;
}

.btn {
  padding: 7px 15px;
  // background-color: rgb(255, 80, 80);
  border-radius: 20px;
}

/*START SCROLL BAR*/

::-webkit-scrollbar {
  border-radius: 20px;
  height: 2.5px;
  width: 5px;
}

::-webkit-scrollbar-track {
  border-radius: 20px;
  transition: background 0.5s;
  background: var(--main-bg-color);
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: rgb(109, 109, 109);
  height: 10px;
  width: 10px;
}
/*END SCROLL BAR*/
</style>
